module.exports = __webpack_public_path__ + "img/grey_033.7755ae68.png";